module.exports = __webpack_public_path__ + "img/1336293324.0d21daab.jpg";